import { Position } from "@/services/backend/htz/position/types/position";
import { createContext, useContext } from "react";
import { PositionCatalog } from "@/services/backend/htz/position-catalog/types/position-catalog";
import { ErrValidationFailed } from "@bitory-gmbh/nidavellir";
import { AirHandlingUnit } from "@/services/backend/htz/ahu/types/air-handling-unit";

export interface PositionsTableContextInterface {
  positions: Position[];
  onPositionsChange: (positions: Position[]) => void;
  validationError: ErrValidationFailed | null;
  setValidationError: (err: ErrValidationFailed | null) => void;
  airHandlingUnits: AirHandlingUnit[];
  positionCatalog: PositionCatalog;
  immutable: boolean;
}

export const PositionsTableContext =
  createContext<PositionsTableContextInterface>({
    positions: [],
    onPositionsChange: () => null,
    validationError: null,
    setValidationError: () => null,
    positionCatalog: {} as PositionCatalog,
    airHandlingUnits: [],
    immutable: false,
  });

export function usePositionTableContext() {
  return useContext(PositionsTableContext);
}
